import CryptoJS from 'crypto-js';

export const encryptData = (data, key) => {
  alert(key);
  return CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
};

export const decryptData = (encryptedData, key) => {
  try {
    console.log('entered key :', key , 'encryptedData :', encryptedData);
    const bytes = CryptoJS.AES.decrypt(encryptedData, key);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    console.log('decryptedData :', decryptedData);
    return JSON.parse(decryptedData);
  } catch (error) {
    console.error('Decryption failed:', error);
    return null;
  }
};

export const validateKey = (encryptedTest, key) => {
  try {
    const decrypted = decryptData(encryptedTest, key);
    return decrypted === 'VALID';
  } catch {
    return false;
  }
};
